/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { SIGNATURE_FLOW } from "@common/model/constants";

// Controller interface
interface IEcvDynamicField {
    item;
    init(): void;
}

// Directive Controller
class EcvDynamicField implements IEcvDynamicField {
    item: any;
    elementId;
    parent;
    parentHeight;
    parentWidth;
    config;
    isSigning;
    itemStyle;
    scale;

    static $inject = ['$scope', '$filter', '$timeout', 'documentSignatureService', 'UtilityService'];
    constructor(
        private $scope,
        private $filter: ng.IFilterService,
        private $timeout: ng.ITimeoutService,
        private documentSignatureService,
        private UtilityService
    ) {

    }
    convertToPercentage;
    convertTopixel;

    init = () => {
        const context = this;
        const flow = this.documentSignatureService.getCurrentFlow();
        this.convertToPercentage = this.UtilityService.convertToPercentage;
        this.convertTopixel = this.UtilityService.convertTopixel;

        this.isSigning = flow == SIGNATURE_FLOW.SIGNING;
        this.config = angular.copy(this.documentSignatureService.fieldConfig[this.item.type]);
        this.config.paddBottom = this.convertToPercentage(this.config.paddBottom, this.parentHeight);
        this.config.paddLeft = this.convertToPercentage(this.config.paddLeft, this.parentHeight);
        if (this.item.id <= 0) {
            // whenever there is new signature or initials then new field's
            //height and width needs to be converted to percentage
            this.item.h = this.convertToPercentage(this.item.h / this.scale, this.parentHeight);
            this.item.w = this.convertToPercentage(this.item.w / this.scale, this.parentWidth);
            this.setFont(this.getScaledH(), true);
        } else {
            this.setFont(this.getScaledH(), true);
        }
        if (this.item.type == this.documentSignatureService.fieldTypes.CHECKBOX) {
            if (!this.item.value) {
                //set default value for checkbox to false
                this.item.value = false;
            } else {
                //if value is present then convert string to boolean
                this.item.value = (this.item.value.toLowerCase() == "true");
            }
        }
        this.elementId = this.documentSignatureService.getDOMElementId(this.item);
        this.$timeout(() => {
            this.parent = $('#' + context.elementId);
            const x = this.convertTopixel(context.getX(), context.parentWidth);
            const y = this.convertTopixel(context.getY(), context.parentHeight);
            const h = this.convertTopixel(context.getScaledH(), context.parentHeight);
            const w = this.convertTopixel(context.getScaledW(), context.parentWidth);
            this.parent.css({
                'top': y + 'px',
                'left': x + 'px',
                'height': h + 'px',
                'width': w + 'px'
            });
            if (flow == SIGNATURE_FLOW.SETUP) {
                //only set up time elements would be draggable
                context.subscribeDraggable(context);
                context.subscribeResizable(context);
            }
        }, 200);
    }

    subscribeDraggable = (context) => {
        this.parent.draggable({
            cursor: "move",
            // obstacle: ".draggable-cntnr",
            // preventCollision: true,
            containment: "#viewerContainer",
            scroll: true,
            start: function (event, ui) {
                context.parent.parent().addClass('dragging');
            },
            stop: function (event, ui) {
                context.parent.parent().removeClass('dragging');
                context.setX(context.convertToPercentage(ui.position.left, context.parentWidth * context.scale));
                context.setY(context.convertToPercentage(ui.position.top, context.parentHeight * context.scale));
            }
        });
    }

    subscribeResizable = (context) => {
        this.parent.resizable({
            maxHeight: 64,
            minHeight: 14,
            handles: 'n,e,s,w',
            containment: "#viewerContainer",
            stop: function (event, ui) {
                if (ui.originalSize.width == ui.size.width) {
                    //if height changed then it is obvious that current fontsize and (x,y) coordinates needs to be updated
                    context.item.h = context.convertToPercentage(ui.size.height / context.scale, context.parentHeight);
                    context.setFont(ui.size.height, false);
                } else {
                    context.item.w = context.convertToPercentage(ui.size.width / context.scale, context.parentWidth);
                }
                context.setX(context.convertToPercentage(ui.position.left, context.parentWidth * context.scale));
                context.setY(context.convertToPercentage(ui.position.top, context.parentHeight * context.scale));
            }
        });
    }

    getScaledH = () => {
        return parseFloat(Number(this.item.h * this.scale).toFixed(4));
    }

    getScaledW = () => {
        return parseFloat(Number(this.item.w * this.scale).toFixed(4));
    }

    getY = () => {
        if (this.item.y) {
            return (100 - (this.item.h - this.config.paddBottom + this.item.y)) * this.scale;
        } else {
            this.setY(90); //default is 90% from top
            return this.getY();
        }
    }

    getX = () => {
        if (this.item.x) {
            return (this.item.x - this.config.paddLeft) * this.scale;
        } else {
            if (this.item.type != 'DATE') {
                this.setX(5); // default left is 5%
            } else {
                this.setX(70); // default left for date is 70%
            }
            return this.getX();
        }
    }

    setY = (y) => {
        //front end takes height from top to bottom and backend takes it from bottom to top so
        // whatever y is calculated here should be substracted from 100% height so the evaluation is like follows
        this.item.y = parseFloat((100 + this.config.paddBottom - y - this.item.h).toFixed(4));
    }

    setX = (x) => {
        this.item.x = parseFloat((x + this.config.paddLeft).toFixed(4));
    }

    setStyles = () => {
        const rtnObj = {
            "font": this.config.currentFont,
            "padding-left": Number(this.config.paddLeft).toFixed(4) + '%'
        };
        if (this.item.styles) {
            if (this.item.styles.font) {
                const arr = this.item.styles.font.split(' ');
                this.item.styles.font = parseInt(arr[0].replace('px', '')) * this.scale + 'px ' + arr[1];
            }
            for (const key in this.item.styles) {
                rtnObj[key] = this.item.styles[key];
            }
        }
        if (this.item.type == this.documentSignatureService.fieldTypes.TEXTAREA &&
            this.item.validations.noOfLines && this.item.validations.noOfLines > 0) {
            //in following line, -2 means the border width of top and bottom border
            const h = this.convertTopixel(this.getScaledH(), this.parentHeight) - 2;
            rtnObj["line-height"] = Math.floor(h / this.item.validations.noOfLines) + "px";
        }
        this.itemStyle = rtnObj;
    }

    setFont = (height, convertTopixel) => {
        const heightInPx = convertTopixel ? this.convertTopixel(height, this.parentHeight) : height;
        const matrix = this.documentSignatureService.heightToFontMatrix;
        const arr = Object.keys(matrix).map(key => parseInt(key, 10));
        const filtered = arr.filter((a) => a <= heightInPx);
        let key;
        if (filtered.length == 0) {
            key = Math.min.apply(Math, arr);
        } else {
            key = Math.max.apply(Math, filtered);
        }
        this.config.currentFont = matrix[key] + 'px ' + this.config.font;
        this.setStyles();
    };


}

// Actual Directive object
function dynamicField(): ng.IDirective {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/common/directive/dynamic-field/templates/dynamic-field.directive.html',
        replace: true,
        controller: EcvDynamicField,
        controllerAs: 'dfVm',
        bindToController: {
            'item': '=',
            'parentHeight': '=',
            'parentWidth': '=',
            'scale': '='
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvDynamicField): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvDynamicField', dynamicField);
